"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ACTIVE_LIST = exports.DEFAULT_LIST_OF_LISTS = exports.ZENLINK_DEFAULT_TOKEN_LIST = exports.DEFULT_TOKEN_LIST_MAP = void 0;
const moonbeam_json_1 = __importDefault(require("./moonbeam.json"));
const moonriver_json_1 = __importDefault(require("./moonriver.json"));
const astar_json_1 = __importDefault(require("./astar.json"));
const amplitude_json_1 = __importDefault(require("./amplitude.json"));
const pendulum_json_1 = __importDefault(require("./pendulum.json"));
const bifrost_kusama_json_1 = __importDefault(require("./bifrost-kusama.json"));
const bifrost_polkadot_json_1 = __importDefault(require("./bifrost-polkadot.json"));
const arbitrum_one_json_1 = __importDefault(require("./arbitrum-one.json"));
const scroll_testnet_json_1 = __importDefault(require("./scroll-testnet.json"));
const scroll_json_1 = __importDefault(require("./scroll.json"));
const base_json_1 = __importDefault(require("./base.json"));
exports.DEFULT_TOKEN_LIST_MAP = {
    'astar': astar_json_1.default,
    'moonriver': moonriver_json_1.default,
    'moonbeam': moonbeam_json_1.default,
    'bifrost-kusama': bifrost_kusama_json_1.default,
    'bifrost-polkadot': bifrost_polkadot_json_1.default,
    'arbitrum-one': arbitrum_one_json_1.default,
    'scroll-testnet': scroll_testnet_json_1.default,
    'scroll': scroll_json_1.default,
    'base': base_json_1.default,
    'amplitude': amplitude_json_1.default,
    'pendulum': pendulum_json_1.default,
};
exports.ZENLINK_DEFAULT_TOKEN_LIST = [
    moonbeam_json_1.default,
    moonriver_json_1.default,
    astar_json_1.default,
    bifrost_kusama_json_1.default,
    bifrost_polkadot_json_1.default,
    arbitrum_one_json_1.default,
    scroll_testnet_json_1.default,
    scroll_json_1.default,
    base_json_1.default,
    amplitude_json_1.default,
    pendulum_json_1.default
];
exports.DEFAULT_LIST_OF_LISTS = [
    'astar',
    'moonriver',
    'moonbeam',
    'bifrost-kusama',
    'bifrost-polkadot',
    'arbitrum-one',
    'scroll-testnet',
    'scroll',
    'base',
    'amplitude',
    'pendulum',
];
exports.DEFAULT_ACTIVE_LIST = [
    'astar',
    'moonriver',
    'moonbeam',
    'bifrost-kusama',
    'bifrost-polkadot',
    'arbitrum-one',
    'scroll-testnet',
    'scroll',
    'base',
    'amplitude',
    'pendulum',
];
